import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

// @ts-ignore
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
// @ts-ignore
const SpeechRecognitionEvent = window.SpeechRecognitionEvent || window.webkitSpeechRecognitionEvent;

@Injectable({
  providedIn: 'root',
})
export class VoiceService {

  // @ts-ignore
  recognition: window.SpeechRecognition | window.webkitSpeechRecognition;
  transcript: Subject<string> = new Subject<string>();
  private listening = false;

  constructor() {
  }

  startListening() {
    try {
      this.listening = true;
      if(!this.recognition) {
        // @ts-ignore
        this.recognition = new SpeechRecognition();
        this.recognition.continuous = true; // Allow continuous recognition
        this.recognition.interimResults = true; // Get interim results
        this.recognition.lang = 'it-IT';
        this.recognition.processLocally = false;

        // Handle recognition events
        this.recognition.onresult = (event: any) => {
          if (!this.listening) {
            return;
          }

          const transcript = Array.from(event.results)
            .map((result: any) => {
              console.debug(result[0].transcript);
              return result[0].transcript
            })
            .join('');
          this.transcript.next(transcript);
        };

        this.recognition.onerror = (event: any) => {
          console.error(event.error);
        };
      }
      this.recognition.start();
    } catch(err) {
      this.listening = false;
      console.error(err);
    }
  }

  stopListening() {
    try {
      this.listening = false;
      this.recognition?.stop();
    } catch (err) {
      console.error(err);
    }
  }

  abortListening() {
    try {
      this.listening = false;
      this.recognition?.abort();
    } catch (err) {
      console.error(err);
    }
  }
}
